export enum PushPopType {
	Tunnel = 0,
	Function = 1,
	FunctionEvaluationFromGame = 2,
}
